<div>
  <div class="back-layer" (click)="closeClicked(false)"></div>
  <div class="add-vendor-form">
    <div class="vendors">
      <div class="vendor-header">
        <span>{{ isEdit ? 'Edit Subcarrier Contracts' : 'Add Subcarrier Contracts' }}</span>
        <div class="go-back" (click)="closeClicked(false)">
          <i class="material-icons arrow">close</i>
        </div>
      </div>

      <div class="content">
        <div class="user-inputs-container">
          <div class="content-header">Contract Details</div>
          <form *ngIf="subcarrierContractsForm" [formGroup]="subcarrierContractsForm">
            <div class="form-field">
              <label>Broker</label>
              <mat-form-field>
                <mat-select formControlName="brokerage" placeholder="Broker" [compareWith]="compareById">
                  <mat-option>
                    <ngx-mat-select-search
                      [placeholderLabel]="'Brokerage'"
                      [noEntriesFoundLabel]="'No matching brokerage found'"
                      [formControl]="brokerFilter"
                    >
                    </ngx-mat-select-search>
                  </mat-option>

                  <mat-option *ngFor="let broker of brokerageOptions$ | async" [value]="broker">
                    {{ broker.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-field">
              <label>Subcarrier</label>
              <mat-form-field>
                <mat-select formControlName="brokerSubcarrier" placeholder="Subcarrier" [compareWith]="compareById">
                  <mat-option>
                    <ngx-mat-select-search
                      [placeholderLabel]="'Subcarrier'"
                      [noEntriesFoundLabel]="'No matching subcarrier found'"
                      [formControl]="subcarrierFilter"
                    >
                    </ngx-mat-select-search>
                  </mat-option>

                  <mat-option *ngFor="let subcarrier of brokerSubcarriers$ | async" [value]="subcarrier">
                    {{ subcarrier.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-field">
              <label>Main Contract</label>
              <mat-form-field>
                <mat-select formControlName="mainContract" placeholder="Main Contract" [compareWith]="compareById">
                  <mat-option>
                    <ngx-mat-select-search
                      [placeholderLabel]="'Main Contract'"
                      [noEntriesFoundLabel]="'No matching contract found'"
                      [formControl]="mainContractFilter"
                    >
                    </ngx-mat-select-search>
                  </mat-option>

                  <mat-option [value]="null">None</mat-option>

                  <mat-option *ngFor="let contract of mainContractOptions$ | async" [value]="contract">
                    {{ contract.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div formArrayName="trailerTypeContracts">
              <div *ngFor="let trailerType of brokerTrailerTypes$ | async; let i = index" class="form-field">
                <label>{{ trailerType.trailerTypeName }} Contract</label>
                <mat-form-field>
                  <mat-select
                    formControlName="{{ i }}"
                    placeholder="{{ trailerType.trailerTypeName }} Contract"
                    [compareWith]="compareById"
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        [placeholderLabel]="trailerType.trailerTypeName + ' Contract'"
                        [noEntriesFoundLabel]="'No matching contract found'"
                        [formControl]="contractFilters[i]"
                      >
                      </ngx-mat-select-search>
                    </mat-option>

                    <mat-option [value]="null">None</mat-option>

                    <mat-option *ngFor="let contract of contractOptions[i] | async" [value]="contract">
                      {{ contract.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <hr class="mb-2" />

            <div formArrayName="contractDeductionTypes">
              <div *ngFor="let deductionType of contractDeductionTypes$ | async; let i = index" class="">
                <div [formGroupName]="i">
                  <div class="form-field">
                    <mat-form-field>
                      <span *ngIf="getDeductionType(i) === 'flat'" matPrefix class="mr-1">$</span>
                      <div class="flex justify-center">
                        <input
                          matInput
                          type="number"
                          autocomplete="off"
                          formControlName="deductionAmount"
                          [placeholder]="deductionType.deductionTypeName"
                        />
                        <span *ngIf="getDeductionType(i) === 'percentage'" matSuffix>%</span>
                      </div>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-select
                        placeholder="Flat / Percentage"
                        formControlName="deductionType"
                        (selectionChange)="onDeductionTypeChange(i)"
                      >
                        <mat-option [value]="null">None</mat-option>
                        <mat-option value="flat">Flat</mat-option>
                        <mat-option value="percentage">Percentage</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <sa-network-active-button [active]="networkActive$$ | async">
              <button
                mat-flat-button
                color="primary"
                (click)="updateSubcarrierContracts()"
                [disabled]="!subcarrierContractsForm.valid"
              >
                {{ isEdit ? 'Edit Contracts' : 'Add Contracts' }}
              </button>
            </sa-network-active-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
